module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.less
// module id = ./src/app/app.component.less
// module chunks = main